export default "__VITE_ASSET__QyyAaujr__"